import { render, staticRenderFns } from "./RegisteredPayDialog.vue?vue&type=template&id=24fffc4a&scoped=true"
import script from "./RegisteredPayDialog.vue?vue&type=script&lang=js"
export * from "./RegisteredPayDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisteredPayDialog.vue?vue&type=style&index=0&id=24fffc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fffc4a",
  null
  
)

export default component.exports